<template>
<button class="record-button" :class="{
        'listening': isListening,
        'connecting': isConnecting,
        'failed': connectFailed
      }" :disabled="isConnecting || !targetLanguage || !sourceLanguage" @click="handleButtonClick">
    <span v-if="isListening">{{ $t("stop") }}</span>
    <span v-else-if="isConnecting">{{ $t("connecting") }}</span>
    <span v-else-if="connectFailed">{{ $t("reconnect") }}</span>
    <span v-else>{{ $t("start") }}</span>
</button>
</template>

  
<script>
export default {
    name: 'ConnectControl',
    props: {
        isListening: Boolean,
        isConnecting: Boolean,
        connectFailed: Boolean,
        targetLanguage: String,
        sourceLanguage: String
    },
    methods: {
        handleButtonClick() {
            this.$emit('click');
        }
    }
};
</script>

  
<style scoped>
.record-button {
    padding: 12px;
    border-radius: 6px;
    height: 44px;
    min-width: 100px;
    font-family: montserrat;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
    background-color: var(--primary-color);
    color: white;
    border: none;
    transition: all 0.3s ease;
}

.record-button:hover:not(:disabled) {
    background-color: #3a80d2;
}

.record-button.listening {
    background-color: #e25c5c;
}

.record-button.connecting {
    background-color: #f0ad4e;
}

.record-button.failed {
    background-color: #d9534f;
}

.record-button:disabled {
    background-color: var(--disabled-color);
    opacity: 0.6;
    cursor: not-allowed;
}
</style>
